/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import { type RefObject, useContext, useImperativeHandle } from 'react';
import { DesktopContext } from '../../desktop/DesktopContext';

export interface AgentDesktopApi {
  openPath: (path: string) => void;
}

/**
 * Gives the Agent provider (which sits above the desktop) a stable handle to the desktop window
 * system, so the provider itself does not re-render on every desktop change. Other Agent readers
 * of `DesktopContext` remain: app commands in `useAgentExperience` (PA-4438), and Quick Find,
 * which is only mounted while open.
 */
function AgentDesktopBridge({ apiRef }: Readonly<{ apiRef: RefObject<AgentDesktopApi | null> }>) {
  const desktop = useContext(DesktopContext);
  useImperativeHandle(apiRef, () => ({ openPath: (path) => desktop?.openPath(path) }), [desktop]);
  return null;
}

export default AgentDesktopBridge;
